const es_messages = require('./es/messages.json')

const SPANISH_STRINGS = {
  translation: es_messages
}

export default SPANISH_STRINGS
